import { Image, Link, Text } from '@belong/ui';
import clsx from 'clsx';
import styles from './request-feature.module.css';

export function RequestFeature() {
  return (
    <div className="mt-2xl gap-md border-green bg-green-light-bg sm:h-6xl sm:gap-2xl sm:pr-xl flex h-auto flex-col items-center rounded border border-solid pr-0 sm:flex-row">
      <Image
        src="/blog/feature_request.png"
        alt="Request Feature"
        className={clsx(
          'border-green sm:ml-md ml-0 max-w-none border-b object-cover sm:border-none',
          styles.image,
        )}
      />
      <div className="flex flex-1 flex-col items-center justify-center sm:items-start">
        <Text fontWeight="semibold" className="text-body sm:text-h3-sm">
          Have an idea to improve Belong?
        </Text>
        <Text className="mt-xs text-p1 sm:text-body">
          Tell the Belong Product team!
        </Text>
        <Link
          variant="solid"
          href="mailto:features-g@belonghome.com"
          target="_blank"
          className="my-sm self-center sm:mb-0 sm:self-end"
          size="large"
        >
          Request A Feature
        </Link>
      </div>
    </div>
  );
}
